import React from "react";
import { ProductListCreateButton } from "../productList/ProductListCreateButton";
import { ProductListSearch } from "../productList/ProductListSearch";
import { useStyles } from "../../../menu/products/categories/CategoriesListController";

interface IProductPageController<T> {
  productList: T[];
  getLabelFunction: (product: T) => string;
  onItemSelect: (product: T | null) => void;
  buttonLabel: string;
  isLoading: boolean;
  renderOptionFunction?: (product: T) => JSX.Element;
  buttonKey?: string;
}

export function ProductPageController<T>({
  productList,
  getLabelFunction,
  onItemSelect,
  buttonLabel,
  isLoading,
  renderOptionFunction,
  buttonKey,
}: IProductPageController<T>) {
  const classes = useStyles();


  return (
    <div className={classes.controls}>
      <ProductListSearch
        productList={productList}
        getOptionLabelFunction={getLabelFunction}
        renderOptionFunction={renderOptionFunction}
        onItemSelection={onItemSelect}
      />
      <div className={"searchBarDivider"} />

      <ProductListCreateButton
        buttonKey={buttonKey}
        isLoading={isLoading}
        onClick={() => {
          onItemSelect(null);
        }}
        title={buttonLabel}
      />
    </div>
  );
}
